<template>
  <div class="my-scenes-apply-body">
    <div class="my-scenes-apply-page-head">
      <router-link to="/after/myGrades/list" tag="a"
        ><a-icon type="left" />返回上一页</router-link
      >
      <span>/</span>
      <p>发布成果</p>
    </div>
    <div class="my-scenes-apply-content-body">
      <div class="my-scenes-apply-info-body">
        <div class="my-scenes-apply-info">
          <template v-if="!verify">
            <a-form-model ref="ruleForm" :model="form" :rules="rules">
              <a-form-model-item label="选择申请方身份" prop="applierType">
                <a-radio-group v-model="form.applierType">
                  <a-radio value="1">场景需求方</a-radio>
                  <a-radio value="2">场景建设方</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="有无榜单" prop="scene">
                <a-radio-group v-model="form.scene" @change="haveScene">
                  <a-radio :value="1">无</a-radio>
                  <a-radio :value="2">有</a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item
                label="关联榜单"
                prop="associate"
                v-if="form.scene == 2"
              >
                <a-select
                  style="width: 600px"
                  v-model="form.associate"
                  placeholder="请选择关联榜单"
                >
                  <a-select-option
                    v-for="item in associateList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.sceneName }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item ref="name" label="成果名称" prop="name">
                <a-input
                  v-model="form.name"
                  placeholder="请填写成果名称"
                  @blur="
                    () => {
                      $refs.name.onFieldBlur();
                    }
                  "
                />
              </a-form-model-item>
              <a-form-model-item ref="field" label="所属领域" prop="field">
                <a-select
                  style="width: 600px"
                  v-model="form.field"
                  placeholder="请选择所属领域"
                >
                  <a-select-option
                    v-for="item in fieldData"
                    :key="item.code"
                    :value="item.code"
                    >{{ item.text }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="成果行业" prop="industry">
                <a-select
                  style="width: 600px"
                  v-model="form.industry"
                  placeholder="请选择成果行业"
                >
                  <a-select-option
                    v-for="item in industryData"
                    :key="item.code"
                    :value="item.code"
                    >{{ item.text }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="成果类别" prop="skill">
                <a-select
                  style="width: 600px"
                  v-model="form.skill"
                  placeholder="请选择成果类别"
                >
                  <a-select-option
                    v-for="item in skillData"
                    :key="item.code"
                    :value="item.code"
                    >{{ item.text }}</a-select-option
                  >
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="建设单位" prop="unit">
                <a-input
                  v-model="form.unit"
                  placeholder="请填写建设单位"
                  disabled
                />
              </a-form-model-item>
              <a-form-model-item ref="contact" label="联系人" prop="contact">
                <a-input
                  v-model="form.contact"
                  placeholder="请填写联系人姓名"
                  @blur="
                    () => {
                      $refs.contact.onFieldBlur();
                    }
                  "
                />
              </a-form-model-item>
              <a-form-model-item
                ref="contactDetails"
                label="联系方式"
                prop="contactDetails"
              >
                <a-input
                  v-model="form.contactDetails"
                  placeholder="请填写联系方式"
                  @blur="
                    () => {
                      $refs.contactDetails.onFieldBlur();
                    }
                  "
                />
              </a-form-model-item>

              <a-form-model-item label="成果简介" prop="desc">
                <a-input
                  v-model="form.desc"
                  type="textarea"
                  placeholder="请填写成果简介"
                />
              </a-form-model-item>
              <a-form-model-item label="成果背景" prop="backgroundDesc">
                <a-input
                  v-model="form.backgroundDesc"
                  type="textarea"
                  placeholder="请填写成果背景"
                />
              </a-form-model-item>
              <a-form-model-item label="成果建设内容" prop="content">
                <editor :value="form.content" v-model="form.content" />
              </a-form-model-item>
              <a-form-model-item label="实施效果" prop="effect">
                <editor :value="form.effect" v-model="form.effect" />
              </a-form-model-item>
              <a-form-model-item style="padding-left: 140px">
                <a-button class="btn-green" @click="onSubmit"> 提交 </a-button>
                <a-button
                  class="btn-white"
                  style="margin-left: 10px"
                  @click="resetForm"
                  >保存</a-button
                >
              </a-form-model-item>
            </a-form-model>
            <div class="upload-fm">
              <a-upload
                name="file"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="action"
                :headers="headers"
                :before-upload="beforeUpload"
                @change="handleChange"
              >
                <img
                  v-if="imageUrl"
                  :src="imageUrl"
                  alt="avatar"
                  style="max-width: 100%"
                />
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">Upload</div>
                </div>
              </a-upload>
              <p>最佳尺寸：372*218</p>
            </div>
          </template>
          <!-- 审核中样式 -->
          <div v-else class="verify-box">
            <img src="@/assets/img/cjsh.png" />
            <p>您发布的成果已提交至平台审核，请耐心等待...</p>
            <div>
              <a-button class="btn-green">查看详情</a-button>
              <a-button class="btn-gray" style="margin-left: 20px"
                >返回列表</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from "@/components/Editor.vue";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
import { getOwnScene, getBidScene, commonCode } from "@/api/scene";
import {
  achvCreateDraft,
  achvUpdateDraft,
  submitAchvDraft,
  submitAchvZero,
} from "@/api/achv";
import { mapGetters } from "vuex";
import { VUE_APP_API_PATH } from "@/store/constant";
export default {
  components: {
    Editor,
  },
  data() {
    return {
      other: "",
      form: {
        applierType: "1",
        name: "",
        field: undefined,
        industry: undefined,
        skill: undefined,
        unit: "",
        contact: "",
        contactDetails: "",
        desc: "",
        backgroundDesc: "",
        scene: 1,
        associate: "",
        content: "",
        effect: "",
        coverAttachmentId: "",
      },
      verify: false,
      rules: {
        name: [
          {
            required: true,
            message: "请填写成果名称",
            trigger: "blur",
          },
        ],
        field: [
          {
            required: true,
            message: "请选择所属领域",
            trigger: "change",
          },
        ],
        industry: [
          {
            required: true,
            message: "请选择成果行业",
            trigger: "change",
          },
        ],
        // skill: [
        //   {
        //     required: true,
        //     message: "请选择成果类别",
        //     trigger: "change",
        //   },
        // ],
        contact: [
          {
            required: true,
            message: "请填写联系人姓名",
            trigger: "blur",
          },
        ],
        contactDetails: [
          {
            required: true,
            message: "请填写联系方式",
            trigger: "blur",
          },
        ],
        desc: [
          {
            required: true,
            message: "请填写成果简介",
            trigger: "blur",
          },
        ],
        // backgroundDesc: [
        //   {
        //     required: true,
        //     message: "请填写成果背景",
        //     trigger: "blur",
        //   },
        // ],
        // content: [
        //   {
        //     required: true,
        //     message: "请填写成果建设内容",
        //     trigger: "blur",
        //   },
        // ],
        // effect: [
        //   {
        //     required: true,
        //     message: "请填写实施效果",
        //     trigger: "blur",
        //   },
        // ],
      },
      loading: false,
      imageUrl: "",
      associateList: [],
      achvInfo: "",
      achvType: "",
      fieldData: [],
      industryData: [],
      skillData: [],
    };
  },
  watch: {
    "form.applierType": function () {
      this.haveScene();
    },
  },
  computed: {
    ...mapGetters(["userInfo", "access_token"]),
    action() {
      return `${VUE_APP_API_PATH}/file/upload/5004`;
    },
    headers() {
      return {
        Authorization: "Bearer " + this.access_token,
      };
    },
  },
  mounted() {
    this.achvInfo = this.$route.params.info;
    this.achvType = this.$route.params.type;
    this.form.unit = this.userInfo.company.companyName;
    this.loadfield();
    this.loadindustry();
    this.loadSkill();
    this.loadFormInfo();
  },
  methods: {
    loadFormInfo() {
      let achvInfo = this.achvInfo;
      if (this.achvType == "edit") {
        this.form.associate = achvInfo.sceneId;
        this.form.applierType = achvInfo.applierType;
        this.form.name = achvInfo.achvName;
        this.form.field = achvInfo.fieldLevelOne;
        this.form.industry = achvInfo.industryLevelOne;
        this.form.skill = achvInfo.skillLevelOne;
        this.form.contact = achvInfo.contactPerson;
        this.form.contactDetails = achvInfo.contactDetail;
        this.form.desc = achvInfo.description;
        this.form.backgroundDesc = achvInfo.background;
        this.form.content = achvInfo.content;
        this.form.effect = achvInfo.effect;
        this.form.coverAttachmentId = achvInfo.coverAttachmentId;
      }
    },
    haveScene() {
      let type = this.form.scene;
      let page = {
        size: 50,
        current: 1,
      };
      if (type == 2) {
        if (this.form.applierType == 1) {
          getOwnScene(page).then((res) => {
            this.associateList = res.data.records;
          });
        } else {
          getBidScene(page).then((res) => {
            this.associateList = res.data.records;
          });
        }
      }
    },
    loadfield() {
      let obj = {
        type: "FIELD",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.fieldData = res.data;
      });
    },
    loadindustry() {
      let obj = {
        type: "INDUSTRY",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.industryData = res.data;
      });
    },
    loadSkill() {
      let obj = {
        type: "SKILL",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.skillData = res.data;
      });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        let _this = this;
        let form = this.form;
        if (valid) {
          let data = {
            sceneId: form.associate,
            applierType: form.applierType,
            achvName: form.name,
            fieldLevelOne: form.field,
            industryLevelOne: form.industry,
            skillLevelOne: form.skill,
            contactPerson: form.contact,
            contactDetail: form.contactDetails,
            description: form.desc,
            background: form.backgroundDesc,
            content: form.content,
            effect: form.effect,
            coverAttachmentId: form.coverAttachmentId,
          };
          if (_this.achvType == "add") {
            submitAchvZero(data).then((res) => {
              _this.$message.success("提交成功！");
              _this.$refs.ruleForm.resetFields();
              setTimeout(function () {
                _this.$router.push("/after/myGrades/list");
              }, 1000);
            });
          } else {
            data.achvId = this.achvInfo.id;
            submitAchvDraft(data).then((res) => {
              _this.$message.success("提交成功！");
              _this.$refs.ruleForm.resetFields();
              setTimeout(function () {
                _this.$router.push("/after/myGrades/list");
              }, 1000);
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      let _this = this;
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            sceneId: form.associate,
            applierType: form.applierType,
            achvName: form.name,
            fieldLevelOne: form.field,
            industryLevelOne: form.industry,
            skillLevelOne: form.skill,
            contactPerson: form.contact,
            contactDetail: form.contactDetails,
            description: form.desc,
            background: form.backgroundDesc,
            content: form.content,
            effect: form.effect,
            coverAttachmentId: form.coverAttachmentId,
          };
          if (_this.achvType == "add") {
            achvCreateDraft(data).then((res) => {
              console.log(res);
              _this.$success({
                title: "保存草稿成功",
                okText: "确定",
                class: "submit-draft-box",
                content: (
                  <div>
                    <p>草稿可在“我的成果-待提交”列表查看</p>
                  </div>
                ),
              });
              setTimeout(function () {
                _this.$router.push("/after/myGrades/list");
              }, 1000);
              _this.$refs.ruleForm.resetFields();
            });
          } else {
            data.achvId = this.achvInfo.id;
            achvUpdateDraft(data).then((res) => {
              console.log(res);
              _this.$success({
                title: "保存草稿成功",
                okText: "确定",
                class: "submit-draft-box",
                content: (
                  <div>
                    <p>草稿可在“我的成果-待提交”列表查看</p>
                  </div>
                ),
              });
              setTimeout(function () {
                _this.$router.push("/after/myGrades/list");
              }, 1000);
              _this.$refs.ruleForm.resetFields();
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        this.form.coverAttachmentId = info.file.response.data.attachmentId;
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return isJpgOrPng && isLt2M;
    },
  },
};
</script>

<style lang="less" scoped>
.my-scenes-apply-body {
  padding: 24px;
  background: #f5f5f5;
  height: 100%;
  .my-scenes-apply-page-head {
    display: flex;
    align-items: center;
    color: #8c8c8c;
    line-height: 14px;
    height: 14px;
    margin-bottom: 24px;
    > a {
      color: #8c8c8c;
    }
    > span {
      margin: 0 6px;
    }
  }
  .my-scenes-apply-content-body {
    display: flex;
    height: calc(100% - 38px);
    .my-scenes-apply-info-body {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      background: #fff;
      padding: 40px 0;
      .my-scenes-apply-info {
        display: flex;
        justify-content: center;
        .ant-form-item {
          display: flex;
        }
        .verify-box {
          text-align: center;
          padding-top: 100px;
          > img {
            display: block;
            margin: 0 auto;
          }
          > p {
            line-height: 14px;
            margin-top: 40px;
          }
          > div {
            display: flex;
            justify-content: center;
            margin-top: 80px;
          }
        }
      }
    }
  }
}
.upload-fm {
  width: 350px;
  height: 200px;
  margin-left: 40px;
}
</style>
<style>
.upload-fm .ant-upload-picture-card-wrapper {
  height: 100%;
}
.upload-fm .ant-upload.ant-upload-select-picture-card {
  width: 100%;
  height: 100%;
}
.my-scenes-apply-info .ant-form-item-label {
  line-height: 32px !important;
  min-width: 140px !important;
  text-align: right;
}
.my-scenes-apply-info input {
  width: 600px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.my-scenes-apply-info select {
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.my-scenes-apply-info textarea {
  width: 600px;
  height: 120px !important;
}
.my-scenes-apply-info .ant-form-item-control {
  line-height: 32px;
}
.submit-draft-box .ant-modal-confirm-btns > button {
  height: 32px;
  line-height: 32px;
  background: #1abc9c !important;
  border-radius: 2px;
  color: #fff !important;
  border-color: #1abc9c !important;
}
</style>
